import React from "react";

export interface IconEyeOffProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconEyeOff: React.FC<IconEyeOffProps> = ({
  width = 32,
  height = 32,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.65007 1.95406C3.18007 1.48406 2.42007 1.48406 1.95507 1.95406C1.49007 2.42406 1.48507 3.18406 1.95007 3.65406L28.3501 30.0541C28.8201 30.5241 29.5801 30.5241 30.0451 30.0541C30.5101 29.5841 30.5151 28.8241 30.0451 28.3591L25.2251 23.5391C25.3601 23.4191 25.4951 23.2991 25.6251 23.1791C27.9651 21.0041 29.5301 18.4091 30.2751 16.6241C30.4401 16.2291 30.4401 15.7891 30.2751 15.3941C29.5301 13.6091 27.9651 11.0091 25.6251 8.83906C23.2701 6.65406 20.0351 4.80906 15.9951 4.80906C13.1551 4.80906 10.7151 5.71906 8.69507 7.01906L3.65007 1.95406ZM11.8251 10.1341C13.0001 9.29406 14.4451 8.79906 16.0001 8.79906C19.9751 8.79906 23.2001 12.0241 23.2001 15.9991C23.2001 17.5541 22.7051 18.9941 21.8651 20.1741L20.1301 18.4391C20.7651 17.3691 20.9801 16.0541 20.6351 14.7541C19.9501 12.1941 17.3151 10.6741 14.7551 11.3591C14.3251 11.4741 13.9201 11.6441 13.5551 11.8591L11.8201 10.1241L11.8251 10.1341ZM17.8651 22.9541C17.2701 23.1141 16.6451 23.1991 16.0001 23.1991C12.0251 23.1991 8.80007 19.9741 8.80007 15.9991C8.80007 15.3541 8.88507 14.7291 9.04507 14.1341L5.07007 10.1591C3.44007 11.9991 2.32007 13.9491 1.72507 15.3841C1.56007 15.7791 1.56007 16.2191 1.72507 16.6141C2.47007 18.3991 4.03507 20.9991 6.37507 23.1691C8.73007 25.3541 11.9651 27.1991 16.0051 27.1991C17.8701 27.1991 19.5651 26.8041 21.0801 26.1691L17.8701 22.9591L17.8651 22.9541Z"
      fill={fill}
    />
  </svg>
);
